import React from 'react';
import DOMPurify from 'dompurify';
import styles from './style.module.css';
import Video from '../../containers/VideoAssessment/components/Video';

const ShowTutorialModal = ({ onCancel, text = '', btnCancel, url }) => (
  <div className="modalWrapper">
    <div className={`modalContent ${styles.tutorialModalContent}`}>
      <span onClick={onCancel} className="timesClosed">
        &times;
      </span>
      {text && (
        <p>
          <span
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(text),
            }}
          />
        </p>
      )}
      <Video src={url} controls playsInline />
      <div className={`modalButtonsGroup ${styles.tutorialModalButtonsGroup}`}>
        <button
          className={`modalButton onCancelBtn ${styles.tutorialModalButton}`}
          type="button"
          onClick={onCancel}
        >
          {btnCancel}
        </button>
      </div>
    </div>
  </div>
);
export default ShowTutorialModal;
